
import { ReactNode } from 'react';

interface SettingCardProps {
  title: string;
  description?: string;
  children: ReactNode;
}

const SettingCard = ({ title, description, children }: SettingCardProps) => {
  return (
    <div className="bg-recallio-dark-gray rounded-lg border border-recallio-light-gray/50 mb-6">
      <div className="p-5">
        <h3 className="text-lg font-medium">{title}</h3>
        {description && <p className="text-muted-foreground text-sm mt-1">{description}</p>}
      </div>
      <div className="border-t border-recallio-light-gray/50 p-5">
        {children}
      </div>
    </div>
  );
};

export default SettingCard;
